export { default as AdminLanding } from './AdminLanding';
export { default as ChangePasswordPage } from './ChangePasswordPage';
export { default as ConfigPage } from './ConfigPage';
export { default as EditDisplayTemplate } from './EditDisplayTemplate';
export { default as EditDocType } from './EditDocType';
export { default as EditDocumentLanding } from './EditDocumentLanding';
export { default as EditDocumentPage } from './EditDocumentPage';
export { default as FileMgmtLanding } from './FileMgmtLanding';
export { default as LoginPage } from './LoginPage';
export { default as MainMenu } from './MainMenu';
export { default as ProfileEditPage } from './ProfileEditPage';
export { default as SignupPage } from './SignupPage';
export { default as ThemePage } from './ThemePage';
export { default as UploadFilePage } from './UploadFilePage';
export { default as UserMgmtLanding } from './UserMgmtLanding';
